import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed, nextTick, onMounted, ref, watch } from 'vue'

interface Props {
  text?: string
  delay?: number
  lineOneSize?: number
  lineTwoSize?: number
  rotation?: number
  mode?: 'toBottomRight' | 'toTopLeft'
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AnimatedSiteMapLocation',
  props: {
    text: null,
    delay: null,
    lineOneSize: { default: 100 },
    lineTwoSize: { default: 200 },
    rotation: { default: 20 },
    mode: { default: 'toTopLeft' }
  },
  setup(__props: any) {

const props = __props as { text?: string, delay?: number, lineOneSize: number, lineTwoSize: number, rotation: number, mode: 'toBottomRight' | 'toTopLeft' };



const element = ref()
const dot = ref()
const lineOne = ref()
const lineTwo = ref()
const text = ref()
const isVisible = ref(false)
const observer = ref<IntersectionObserver>()

onMounted(() => {
  observer.value = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      isVisible.value = entry.isIntersecting
    })
  })

  observer.value.observe(element.value)
})

watch(isVisible, (value) => {
  if (value) {
    nextTick(() => {
      if (props.delay) {
        setTimeout(animate, props.delay)
      } else {
        animate()
      }
    })
  } else {
    lineOne.value.style.opacity = '0'
    lineTwo.value.style.opacity = '0'
    text.value.style.opacity = '0'
  }
})

const lineOneStyle = computed(() => ({
  height: `${props.lineOneSize}px`,
  transform:
    props.mode === 'toTopLeft'
      ? `translate(-50%, -100%) rotateZ(-${props.rotation}deg)`
      : `rotateZ(-${props.rotation}deg)`,
  transformOrigin: props.mode === 'toTopLeft' ? 'bottom right' : 'top left',
}))

const lineTwoStyle = computed(() => {
  const rotationRadians = (props.rotation * Math.PI) / 180
  const translateX =
    props.mode === 'toTopLeft'
      ? -props.lineTwoSize - props.lineOneSize * Math.sin(rotationRadians)
      : props.lineOneSize * Math.sin(rotationRadians)
  const translateY =
    props.mode === 'toTopLeft'
      ? -props.lineOneSize * Math.cos(rotationRadians)
      : props.lineOneSize * Math.cos(rotationRadians)
  return {
    width: `${props.lineTwoSize}px`,
    transform: `translate(${translateX}px, ${translateY}px)`,
    transformOrigin: props.mode === 'toTopLeft' ? 'bottom right' : 'top left',
  }
})

const textStyle = computed(() => {
  const rotationRadians = (props.rotation * Math.PI) / 180
  const translateX =
    props.mode === 'toTopLeft'
      ? -props.lineTwoSize - props.lineOneSize * Math.sin(rotationRadians)
      : props.lineTwoSize + props.lineOneSize * Math.sin(rotationRadians)
  const translateY =
    props.mode === 'toTopLeft'
      ? -props.lineOneSize * Math.cos(rotationRadians)
      : props.lineOneSize * Math.cos(rotationRadians)
  return {
    transform:
      props.mode === 'toTopLeft'
        ? `translate(calc(${translateX}px - 100%), calc(${translateY}px - 50%))`
        : `translate(calc(${translateX}px), calc(${translateY}px - 50%))`,
  }
})

function animate() {
  dot.value.animate(
    [
      { transform: `translate(-50%, -50%) scale(0)`, opacity: 1 },
      { transform: `translate(-50%, -50%) scale(1)`, opacity: 1 },
    ],
    {
      duration: 1000,
      easing: 'ease-in-out',
      fill: 'forwards',
    }
  )
  lineOne.value.animate(
    [
      { transform: `${lineOneStyle.value.transform} scaleY(0)`, opacity: 1 },
      { transform: `${lineOneStyle.value.transform} scaleY(1)`, opacity: 1 },
    ],
    {
      duration: 1000,
      delay: 500,
      easing: 'ease-in-out',
      fill: 'forwards',
    }
  )
  lineTwo.value.animate(
    [
      { transform: `${lineTwoStyle.value.transform} scaleX(0)`, opacity: 1 },
      { transform: `${lineTwoStyle.value.transform} scaleX(1)`, opacity: 1 },
    ],
    {
      duration: 1000,
      delay: 500 + 1000,
      easing: 'ease-in-out',
      fill: 'forwards',
    }
  )
  text.value.animate([{ opacity: 0 }, { opacity: 1 }], {
    duration: 1000,
    delay: 500 + 1000,
    easing: 'ease-in-out',
    fill: 'forwards',
  })

  if (observer.value) observer.value.unobserve(element.value) // Do not animate again
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "animated-sitemap-location",
    ref_key: "element",
    ref: element
  }, [
    _createElementVNode("div", {
      ref_key: "dot",
      ref: dot,
      class: "animated-site-location-dot"
    }, null, 512 /* NEED_PATCH */),
    _createElementVNode("div", {
      ref_key: "lineOne",
      ref: lineOne,
      class: "animated-site-location-line-one",
      style: _normalizeStyle(_unref(lineOneStyle))
    }, null, 4 /* STYLE */),
    _createElementVNode("div", {
      ref_key: "lineTwo",
      ref: lineTwo,
      class: "animated-site-location-line-two",
      style: _normalizeStyle(_unref(lineTwoStyle))
    }, null, 4 /* STYLE */),
    _createElementVNode("div", {
      ref_key: "text",
      ref: text,
      class: "animated-site-location-text",
      style: _normalizeStyle(_unref(textStyle))
    }, _toDisplayString(props.text), 5 /* TEXT, STYLE */)
  ], 512 /* NEED_PATCH */))
}
}

})